import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from './BaseComponent';
import { InputBox } from './InputBox';
import { UIHelper } from '../utils/UIHelper';
import { GlobalHelper } from '../utils/GlobalHelper';
import { VisibilityActions } from '../actions/VisibilityActions';
import { VisibilityStore, LengthDialogData } from '../stores/VisibilityStore';

interface LengthInputDialogState {
    data: LengthDialogData | null;
}

export class LengthInputDialog extends BaseComponent<{}, LengthInputDialogState> {
    protected inputBox: InputBox;
    public componentWillMount(): void {
        this.addStoreListener(VisibilityStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (this.state.data == null) {
            return null;
        }
        return (
            <div className="floating-inputbox-overlay" onClick={this.onClose}>
            <div
                className="floating-inputbox"
                onClick={UIHelper.stopEvent}
                style={{
                    left: this.state.data.clickedElement.getBoundingClientRect().right,
                    top: this.state.data.clickedElement.getBoundingClientRect().top
                }}
            >
                <InputBox
                    className="input-floating"
                    defaultValue={this.state.data.defaultValue}
                    ref={(node: InputBox) => { this.inputBox = node; }}
                    focus={true}
                    inputType="text"
                    submitCallback={this.submit}
                    noTextHelper={true}
                />
                {this.directionButtons()}
            </div>
            </div>
        );
    }

    protected onChange = (): void => {
        this.setState({data: VisibilityStore.getState().lengthDialog});
    };

    protected onClose = (): void => {
        if (this.state.data != null) {
            this.state.data.onCancel();
        }

        VisibilityActions.closeLengthDialog();
    };

    protected directionButtons = (): JSX.Element | null => {
        if (this.state.data != null && ['Wall:length_left', 'Wall:length_right'].indexOf(this.state.data.id) === -1) {
            return null;
        }

        return (
            <div className={'floating-inputbox-buttons'}>
                <div
                    className={'floating-inputbox-left' + (GlobalHelper.roomManager.changeWallLengthToRight ? '' : ' floating-inputbox-active-button')}
                    onClick={this.onLeftClick}
                />
                <span>{t('Direction')}</span>
                <div
                    className={'floating-inputbox-right' + (GlobalHelper.roomManager.changeWallLengthToRight ? ' floating-inputbox-active-button' : '')}
                    onClick={this.onRightClick}
                />
            </div>
        );
    };

    protected onLeftClick = (): void => {
        GlobalHelper.roomManager.changeWallLengthToRight = false;
        this.setState(this.state);
    };

    protected onRightClick = (): void => {
        GlobalHelper.roomManager.changeWallLengthToRight = true;
        this.setState(this.state);
    };

    protected submit = (): void => {
        if (this.inputBox) {
            const value: string = this.inputBox.value as string;
            if (this.state.data != null) {
                this.state.data.onSubmit(GlobalHelper.getValueFromLocaleLengthString(value));
            }
        }
        UIHelper.blurKeyboard();
        VisibilityActions.closeLengthDialog();
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LengthInputDialog.tsx